import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { GiveBack } from './pages/GiveBack';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f8ndlgc3j77i">
      <div className="w-full bg-cream" data-id="element-1" data-mp="2rknmugesbgsx">
        <ScrollToTop data-id="element-2" data-mp="2rlp10tr3kjev" />
        <Header data-id="element-3" data-mp="2rit14zvovkns" />
        <Routes data-id="element-4" data-mp="2mlu8ymvl5ns8">
          <Route path="/" element={<Home data-id="element-6" data-mp="2mmvj8p4s268w" />} data-id="element-5" data-mp="2mm2j470bqezq" />
          <Route path="/about" element={<About data-id="element-8" data-mp="2mjzmv58kvpmk" />} data-id="element-7" data-mp="2mndr6j0sy8wn" />
          <Route path="/give-back" element={<GiveBack data-id="element-10" data-mp="31bi9vmzuukff" />} data-id="element-9" data-mp="31b8j3x6zk98o" />
        </Routes>
        <Footer data-id="element-11" data-mp="31cjjro54x0vk" />
      </div>
    </BrowserRouter>;
}